/* global axios */
import ApiClient from './ApiClient';

class TalkviaOpenAIConfigAPI extends ApiClient {
  constructor() {
    super('talkvia_openai_config', { accountScoped: true });
  }

  update(data) {
    return axios.patch(this.url, { talkvia_openai_config: data });
  }
}

export default new TalkviaOpenAIConfigAPI();
